import React from 'react';
import {io} from 'socket.io-client';


//local version --------------------------------------------------------
//const socketServerUrl = 'http://localhost:5002';

//live version render currently used at 26.May.2025----------------------------------------------------------------
const socketServerUrl = 'https://ludisgroup-erp-back-socket.onrender.com';





//live version Heroku----------------------------------------------------------------
 //const socketServerUrl = 'https://ludisgroup-erp-back-socket.herokuapp.com';
export const mySocket = io(socketServerUrl) ;

export const SocketContext = React.createContext();